














import Vue from "vue";

export default Vue.extend({
  name: "Alert",
  props: {
    type: String,
    display: Boolean,
    message: String,
    callback: Function,
    closeButton: Boolean
  }
});
